import axios from '../axios'

/* 
 * 轮播图模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/banner/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/banner/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/banner/findPage',
        method: 'post',
        data
    })
}
export const getSort = (data) => {
    return axios({
        url: '/banner/getSort',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/banner.js